import axios from "axios";
import { makeQueryString } from "../utils/Query.js";
import { env } from "@/api/ApiEnv.js";
const API_BASE_URL = process.env.VUE_APP_API_URL;

const config = {
    baseUrlDgshp: API_BASE_URL + "/common/file/dgshp/"
};

const fileAPIDgshp = {
    fileDownloadApi: conditions => {
        var str = encodeURI(`${makeQueryString(conditions)}`);
        return axios.get(
            `${config.baseUrlDgshp}fileDownload` + str,
            {
                responseType: "arraybuffer"
            }
        );
    },
}

export { fileAPIDgshp };

